"use client";

import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  server_post_data,
  apple_login,
  login_user_email,
  get_bus_counter_by_id,
} from "../../../ServiceConnection/serviceconnection";
import { handleError } from "../../../CommonJquery/CommonJquery";
import { storeData } from "../../../LocalConnection/LocalConnection";
import wowLogo from "./../../../Assets/newLogo.png";
export default function CallbackApple() {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("loading");
  const [errorMessage, setErrorMessage] = useState("");
  const [IsLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleSignIn = async () => {
      try {
        let firstName = "";
        let lastName = "";
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get("code");

        if (!code) {
          setStatus("error");
          setErrorMessage("No authorization code found in the URL");
          return;
        }

        let fd = new FormData();
        fd.append("code", code);
        if (firstName !== "") {
          fd.append("first_Name", firstName);
        }
        if (lastName !== "") {
          fd.append("last_Name", lastName);
        }

        const Response = await server_post_data(apple_login, fd);
        const data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        // Error responses come back as a "<flag>~@~<jsonString>" string,
        // success responses come back as an object with { status, data }.
        if (final_data.error) {
          setStatus("error");
          setErrorMessage(final_data.message || "Apple sign-in failed");
          handleError(final_data.message);
        } else {
          handleGoogleLoginSuccess(final_data);
        }
      } catch (error) {
        console.error("Sign-in error:", error);
        setStatus("error");
        setErrorMessage(
          error instanceof Error ? error.message : "An unknown error occurred",
        );
      }
    };

    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get("code")) {
      handleSignIn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, navigate]);

  const handleGoogleLoginSuccess = async (response) => {
    try {
      let email = response.data.email;
      handleSubmit(2, email, "IOS");
    } catch (error) {
      console.error("Apple login error:", error);
      setStatus("error");
      setErrorMessage("Failed to process Apple login");
    }
  };

  const handleSubmit = async (flag, email = "", loginType = "normal") => {
    var formdata = new FormData();
    formdata.append("user_email", email);
    formdata.append("flag", "2");
    formdata.append("by_login", loginType);
    setIsLoading(true);
    await server_post_data(login_user_email, formdata)
      .then(async (Response) => {
        setIsLoading(false);
        const data = Response.message.split("~@~");
        const final_data2 = JSON.parse(data[1]);
        const final_data = final_data2.user_data;
        setStatus("success");
        storeData("final_user_moblie_no", final_data[0].mobile_no);
        storeData("customer_id", final_data[0].buu_id);
        if (Number.parseInt(final_data[0].bus_id) !== 0) {
          var formdata22 = new FormData();
          formdata22.append("bus_id_for", final_data[0].bus_id);
          setIsLoading(true);
          await server_post_data(get_bus_counter_by_id, formdata22)
            .then(async (Response) => {
              setIsLoading(false);
              const data = Response.message.split("~@~");
              const final_data2222 = JSON.parse(data[1]);
              if (parseInt(data[0]) === 1) {
                handleError(final_data2222.message);
              } else {
                storeData("final_full_name", final_data[0].full_name);
                storeData("final_user_email", final_data[0].email_id);
                storeData("final_bus_id", final_data[0].bus_id);
                storeData("user_image", final_data[0].image);
                storeData("access_token", final_data[0].access);
                storeData("refresh_token", final_data[0].refresh);
                storeData(
                  "price_amount_package",
                  final_data2222.package_amount,
                );
                storeData("counter_bus_id", final_data2222.count_session);
                storeData("user_image_path", final_data2222.user_linkss_link);
                navigate("/");
              }
            })
            .catch((error) => {
              setIsLoading(false);
              handleError("network");
            });
        } else {
          navigate("/onboarding");
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        setStatus("error");
        setErrorMessage("Network error while logging in");
        handleError("network");
      });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-white">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-lg">
        <div className="flex justify-center mb-6">
          <img
            src={wowLogo}
            alt="WowReviews Logo"
            width={180}
            height={40}
            style={{ maxWidth: "180px" }}
          />
        </div>

        <div className="flex flex-col items-center justify-center space-y-4 text-center">
          {status === "loading" && (
            <>
              <div className="flex items-center justify-center w-12 h-12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-orange-500 animate-spin"
                  width={24}
                  height={24}
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Verifying your credentials
              </h2>
              <p className="text-gray-600">
                Please wait while we complete your sign-in...
              </p>
            </>
          )}

          {status === "success" && (
            <>
              <div className="flex items-center justify-center w-12 h-12 bg-green-100 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-green-600"
                  width={24}
                  height={24}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Sign-in Successful!
              </h2>
              <p className="text-gray-600">
                Redirecting you to your dashboard...
              </p>
            </>
          )}

          {status === "error" && (
            <>
              <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-red-600"
                  width={20}
                  height={20}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                Authentication Failed
              </h2>
              <p className="text-gray-600">
                {errorMessage || "There was an error processing your sign-in."}
              </p>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm font-medium text-white bg-orange-500 rounded-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
              >
                Return to Login
              </button>
            </>
          )}
        </div>
      </div>

      <div className="mt-6 text-center text-sm text-gray-500">
        © 2026 Wowreviews. All rights reserved.
        <div className="mt-1">
          <a href="/terms" className="text-gray-600 hover:text-orange-500">
            Terms of Service
          </a>
          {" & "}
          <a href="/privacy" className="text-gray-600 hover:text-orange-500">
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
}
